<script lang="ts">
import {defineComponent, type PropType} from "vue";
  import SectionDemandeAttestationList from '@/generated/sections/SectionDemandeAttestationList.vue';
  import {FwkSections, RessourceFwkSection} from "@/ressources/globalRessources.ts";
  import Section from "@/framework/base/classes/Section.ts";
  import SectionApprenti from "@/extend/sections/SectionApprentiExtend.vue";
  import SectionDemandeAttestation from "@/extend/sections/SectionDemandeAttestationExtend.vue";
  import Apprenti from "@/extend/classes/Apprenti.ts";
  import Attestation from "@/extend/classes/Attestation.ts";
  import AttestationDef from "@/extend/classes/AttestationDef.ts";
  import {ColumnFilter, ListChoix} from "@/extend/classes/ListData.ts";
  import { storeAttestationDef, storeAttestation, storeEtablissement} from "@/generated/stores";
import Etablissement from "@/extend/classes/Etablissement.ts";
import AccidentTravail from "@/extend/classes/AccidentTravail.ts";
  export default defineComponent({
    extends: SectionDemandeAttestationList,
    components: {},
    props: {
      etablissement: {
        type: Object as PropType<Etablissement>,
        required: true
      }
    },
    data() {
      return {
        selectedAttestation: new Attestation(),
        isCardView: true
      };
    },
    computed: {
      canAdd(): boolean {
        return false;
      },
      showSearch(): boolean {
        return false;
      },
      section(): Section {
        const section = new Section();
        section.component = SectionDemandeAttestation;
        section.type = 'attestation';
        section.data = this.selectedAttestation;
        section.ressource = this.ressource;
        section.isAbstract = this.isAbstract;
        return section;
      }
    },
    methods: {
      defaultFilter(): void {
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "etablissementId";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = this.etablissement.id
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
      },
      getTitle(value: any): string {
        const def = storeAttestationDef.getAttestationDef(value);
        return def.organisme + ' ' + def.caisse;
      },
      extendLabel(name: string, item: number, obj: unknown): string | undefined {
        if (name == 'statut') {
          const attestation = obj as Attestation;
          return Attestation.statusLabel(attestation.statut);
        }
        return undefined;
      },
      addItem(): void {
        this.selectedAttestation = storeAttestation.createNewAttestation();
        this.selectedAttestation.etablissementId = this.etablissement.id;
        if (this.isAbstract) {
          this.$emit("openCrud", this.section);
        } else {
          this.dialogOpen = true;
        }
      },
      selectItemCard(item: any): void {
        const obj = item as Attestation;
        this.selectedAttestation = storeAttestation.getAttestation(obj.id);
        if (this.isAbstract) {
          this.$emit("openCrud", this.section);
        } else {
          this.dialogOpen = true;
        }
      },
      updateItem(item: unknown): void {
        this.selectedAttestation.fromAttestation(item as Attestation)
        this.dialogOpen = true;
      }
    }
  })
</script>
